import Link from 'next/link';
import React from 'react';

export const FooterSecondary = (): JSX.Element => {
  return (
    <div>
      <img
        src="https://res.cloudinary.com/samvibes/image/upload/landing/footer_secondry.png"
        alt="footer"
        className="w-full"
      />
      <div className="bg-primary-150">
        <div className="mobile:mx-24 laptop:mx-164 mobile:pb-58 laptop:pb-28 pt-0 bigScreen:max-w-1076 bigScreen:mx-auto">
          <div className="w-full z-20 flex mobile:flex-col-reverse  desktop:flex-row justify-between">
            <div className="desktop:w-43p my-auto flex flex-col mobile:justify-items-center desktop:justify-items-start">
              <div
                className="text-primary-800 mobile:text-center desktop:text-left laptop:text-7xl  mobile:text-6xl font-bold mb-24"
                style={{ lineHeight: '100%' }}
              >
                Ready to scale your startup?
              </div>
              <div className="mb-32 text-gray-600 mobile:mx-auto desktop:mx-0  mobile:w-full mobile:text-center desktop:text-left">
                The all-in-one productivity suite to bring your team on the same page
              </div>

              <Link href={'/signup'}>
                <a className="mobile:mx-auto desktop:mx-0 text-center tablet:w-256  bg-primary-500 text-white py-13 mobile:w-full  rounded">
                  Get started
                </a>
              </Link>
            </div>
            <img
              src="https://res.cloudinary.com/samvibes/image/upload/c_scale,w_500/landing/frances-and-nancy-as-technicians.png"
              alt="Frances Love, Nancy Newman and technical engineers smiling and fixing equipment."
              className="desktop:w-500 desktop:h-400 mobile:w-256 tablet:w-400 desktop:mx-0 mobile:mx-auto overflow-hidden desktop:-mt-24 bigScreenTwo:-mt-54"
            />
          </div>
        </div>
      </div>
    </div>
  );
};
